import Slide from '@/components/shared/Slide';
import ProgramCard from '@/components/shared/ProgramCard';
import type { GrantProgram, ViewMode } from '@/types/roadmap.types';

interface Props {
  category: string;
  programs: GrantProgram[];
  mode: ViewMode;
}

export default function CategoryDetailSlide({
  category,
  programs,
  mode,
}: Props) {
  return (
    <Slide mode={mode}>
      <div className="w-full mx-auto">
        <div className="mb-8 print:mb-3">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-3 print:mb-1 print:text-[8pt]">
            {category}
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground print:text-[14pt]">
            {programs.length} Program{programs.length > 1 ? 's' : ''}
          </h2>
        </div>

        <div className="space-y-4 print:space-y-0">
          {programs.map((prog, i) => (
            <div
              key={prog.id}
              className={
                i > 0
                  ? 'deck-print-program print:break-before-page'
                  : 'deck-print-program'
              }
            >
              <ProgramCard program={prog} viewMode={mode} />
            </div>
          ))}
        </div>
      </div>
    </Slide>
  );
}
